import {LamellaSetInterface} from "./lamella-set.interface";
import {ColorInfo} from "../../../../core/util/color-converter";
import {Quaternion, Vector3} from "three";

export class LamellaSet implements LamellaSetInterface {
    constructor(
        public id: string,

        public name: string,

        /**
         * Product code; lamellaSet.lamella.product.productCode (backend path)
         */
        public productCode: string,

        /**
         * Space before lamellaSet if set category changes
         */
        public spaceBefore: number,

        /**
         * Space after lamellaSet if set category changes
         */
        public spaceAfter: number,

        /**
         * span of lamella installation width (26.5 increments so far)
         */
        public lamellaSpace: number,

        /**
         * Space between lamellas (when same type of product)
         */
        public lamellaSpaceBetween: number,

        /**
         * How many times the lamella is repeated
         */
        public lamellaRepeat: number,

        /**
         * Height of lamella
         */
        public height: number,

        /**
         * Depth of lamella
         */
        public depth: number,

        /**
         * Maximum span between frames
         */
        public maxFrameSpan: number,

        /**
         * URL to 3D model of lamella
         */
        public object3dUrl: string,

        /**
         * ID of lamella
         */
        public lamellaId: number,

        /**
         * Material of lamella
         */
        public material: 'Powder Coated' | 'Anodized',

        /**
         * Hex value of color of lamella
         */
        public color: ColorInfo,

        /**
         * Offset vector
         */
        public offsetPosition : Vector3,

        /**
         * Offset rotation
         */
        public offsetRotation : Quaternion
    ) {}

}